module.exports = __webpack_public_path__ + "static/img/5.a6146bc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/11/zh/5.png
// module id = xgfH
// module chunks = 0